export default {
  path: '/basic',
  name: 'basic',
  component: () => import('@/layouts/BaseLayout'),
  redirect: '/basic/client_classification',
  children: [
    {
      path: 'custom',
      meta: { title: '客户', permission: 'custom' },
      component: () => import('@/views/custom/index'),
    },
    {
      path: 'warehouse',
      meta: { title: '仓库', permission: 'warehouse' },
      component: () => import('@/views/basic/warehouse/index'),
    },
    {
      path: 'settlement-account',
      meta: { title: '结算账户', permission: 'settlement-account' },
      component: () => import('@/views/basic/settlementAccount/index'),
    },
    {
      path: 'revenue-expenditure',
      meta: { title: ' 收支项目', permission: 'revenue-expenditure' },
      component: () => import('@/views/basic/revenueExpenditureItems/index'),
    },
  ],
}